import RatesRoamingSearch from "../../../components/Rates/RatesRoamingSearch";
import RatesRoamingTabs from "../../../components/Rates/RatesRoamingTabs";
import RatesAdditionalServices from "../../../components/Rates/RatesAdditionalServices";
import RateServiceListItem from "../../../components/Rates/RateServiceListItem";
import React, {useState} from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {
    roamingSearch,
    roamingSearchPlaces
} from "../../../actions/roaming";


function RoamingWorld(props){

    const {activeTabId,
        roaming_i_go_example_regions,
        roamingSearchResult,
        servicesIGo,
        currentPageRoaming} = props;

    const [inSearchIGo, setInSearchIGo] = useState(false);

    function  fetchRoamingSearchPlaces (search, international)  {
        props.getRoamingSearchPlaces(search, international)
    }

    function fetchRoamingSearch  (region, regionId, international)  {
        props.getRoamingSearchResult(region, regionId, international);
    }



    return (
        <div>
            <h2 className="page__title-2">Звонки во время путешествий по миру</h2>
            <div className="page__subtitle">Напишите
                название страны, в
                которой вы находитесь, и рассчитайте
                стоимость звонка домой.
            </div>
            <RatesRoamingSearch
                placeholder={"Укажите страну"}
                defaultValue={props.roaming.placeFromUrl}
                setInSearch={()=>setInSearchIGo(true)}
                activeTab={activeTabId}
                searchItemsMethod={(search) => fetchRoamingSearchPlaces(search, activeTabId === 0 ? 0 : 1)}
                searchMethod={(region, regionId) => fetchRoamingSearch(region, regionId, activeTabId === 0 ? 0 : 1)}
                searchItems={props.roaming.roamingSearchPlacesList}
                exampleRegions={roaming_i_go_example_regions}
            />
            {
                roamingSearchResult.length > 0 || inSearchIGo
                    ? <RatesRoamingTabs inSearch={inSearchIGo}
                                        tabs={roamingSearchResult}
                                        isOk={props.roaming.roamingFirstRequest}/>
                    : ''
            }


        </div>
    )
}

export default withRouter(connect(
    state => ({
        services: state.services,
        infoBlocks: state.infoBlocks,
        faq: state.faq,
        roaming: state.roaming,
    }),
    (dispatch) => {
        return {
            getRoamingSearchPlaces: (search, international) => dispatch(roamingSearchPlaces(search, international)),
            getRoamingSearchResult: (region, regionId, international) => dispatch(roamingSearch(region, regionId, international)),
        }
    }
)(RoamingWorld));